<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="YongHuList" data-title="会议管理">
      <el-segmented
        v-model="state.params.status"
        :props="{
          label: 'Text',
          value: 'Key',
        }"
        :options="[{ Text: '全部' }, ...$base.Meeting_Status]"
        class="c-segmented"
        @change="onLoad()"
      />
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column :width="100" align="center">
          <template #header>
            <div
              class="c-table-col-header text-center w-full"
              label1="状态"
              label2="倒计时"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup :key="row.id">
              <template #top>
                <c_status
                  arrName="Meeting_Status"
                  showBg
                  :value="row.status"
                  class="m-auto"
                  :key="row.status"
                />
              </template>
              <template #bottom>
                <div class="items-center" v-if="row.countdown_days > 0">
                  <text
                    class="font-bold"
                    :class="row.countdown_days < 6 ? 'text-orange-400' : ''"
                  >
                    {{ row.countdown_days }}天
                  </text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column :min-width="260">
          <template #header>
            <div class="c-table-col-header" label1="名称" label2="编号/说明" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row.address" :key="row.id">
              <template #top>
                <div
                  class="flex items-center gap-x-2 text-green-700 cursor-pointer hover:underline"
                  @click="
                    $openMenu({
                      path: 'HuiYiDetail',
                      title: '会议详情-' + row.name,
                      refresh: true,
                      data: {
                        id: row.id,
                      },
                    })
                  "
                >
                  <strong>{{ row.name }}</strong>
                  <text>{{ "[" + row.number + "]" }}</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          label="会议日期"
          sortable="start_date"
          :formatter="(row) => $tab_GroupFormat(row.start_date, row.end_date)"
          :width="120"
          align="center"
        />
        <el-table-column label="会议天数" align="center" :width="120">
          <template #default="{ row }"> {{ row.days }}天 </template>
        </el-table-column>
        <el-table-column
          label="报名时间"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                $dayjs(row.signup_start_time).format('YYYY-MM-DD HH:mm'),
                $dayjs(row.signup_end_time).format('YYYY-MM-DD HH:mm'),
              )
          "
          :width="160"
        />
        <el-table-column align="right" :width="100">
          <template #header>
            <div
              class="c-table-col-header float-right"
              label1="应收款"
              label2="欠款"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup v-if="row.meetingAccounting?.receivable_amount">
              <template #top>
                <c_money
                  :value="row.meetingAccounting?.receivable_amount"
                  :key="row.meetingAccounting?.receivable_amount"
                  :prefix="false"
                  class="float-right"
                  color="#080"
                />
              </template>
              <template #bottom>
                <c_money
                  :value="row.meetingAccounting?.uncollected_amount"
                  :key="row.meetingAccounting?.uncollected_amount"
                  :prefix="false"
                  class="float-right mt-1"
                  color="#a2a2a2"
                  :size="12"
                />
              </template>
            </c_tabgroup>
            <text v-else>-</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="meetingAccounting.bill_amount"
          label="报账总金额(乙方)"
          :formatter="$tab_PriceFormat"
          align="right"
          :width="140"
        />
        <el-table-column :width="160" align="right">
          <template #header>
            <div
              class="c-table-col-header float-right"
              label1="采购金额合计"
              label2="税务成本"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup v-if="row.meetingAccounting?.purchase_amount">
              <template #top>
                <c_money
                  :value="row.meetingAccounting?.purchase_amount"
                  :key="row.meetingAccounting?.purchase_amount"
                  :prefix="false"
                  class="float-right"
                  color="#606266"
                />
              </template>
              <template #bottom>
                <c_money
                  :value="row.meetingAccounting?.cost_tax_fee_amount"
                  :key="row.meetingAccounting?.cost_tax_fee_amount"
                  :prefix="false"
                  class="float-right mt-1"
                  color="#a2a2a2"
                  :size="12"
                />
              </template>
            </c_tabgroup>
            <text v-else>-</text>
          </template>
        </el-table-column>
        <el-table-column :width="140" align="right">
          <template #header>
            <div
              class="c-table-col-header float-right"
              label1="毛利"
              label2="会议结转收入"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup v-if="row.meetingAccounting?.gross_profit">
              <template #top>
                <c_money
                  :value="row.meetingAccounting?.gross_profit"
                  :key="row.meetingAccounting?.gross_profit"
                  :prefix="false"
                  class="float-right"
                  color="#606266"
                />
              </template>
              <template #bottom>
                <c_money
                  :value="row.meetingAccounting?.forward_amount"
                  :key="row.meetingAccounting?.forward_amount"
                  :prefix="false"
                  class="float-right mt-1"
                  color="#a2a2a2"
                  :size="12"
                />
              </template>
            </c_tabgroup>
            <text v-else>-</text>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="住宿"
          prop="accommodation"
          :width="120"
          align="center"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="用餐"
          prop="catering"
          :width="120"
          align="center"
          :formatter="$tab_TextFormat"
        /> -->
        <el-table-column label="项目经理" :width="140">
          <template #default="{ row }">
            <text>{{ row.belonger_name }}</text>
            <text class="text-gray-400 text-xs ml-1">{{
              row.belonger_department_name
            }}</text>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" :width="240">
          <template #default="{ row }">
            <el-button
              type="warning"
              :icon="Edit"
              link
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
              >编辑
            </el-button>
            <el-button
              type="success"
              :icon="Connection"
              link
              @click="
                $openMenu({
                  path: 'HuiYiDetail',
                  title: '会议详情-' + row.name,
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
              >管理
            </el-button>
            <el-button type="danger" :icon="Delete" link @click="onDelete(row)"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>

    <el-dialog
      v-model="state.showInfo"
      :title="state.selectId ? '编辑会议' : '新建会议'"
      class="c-el-dialog"
      :before-close="
        () => {
          state.showInfo = false;
        }
      "
      :lock-scroll="false"
    >
      <c_info
        :id="state.selectId"
        @close="
          state.showInfo = false;
          onLoad();
        "
      />
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { meeting_page, meeting_delete } from "@/http/meeting";
import { onDeleteConfirm } from "@/utils/funcs";

import c_info from "./Info.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  components: {
    c_info,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.bmData;

      meeting_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(meeting_delete, row.id, onLoad, {
        filed: "会议",
        name: row.name,
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    return { state, onLoad, onDelete, onSortChange };
  },
};
</script>

<style lang="scss" scoped></style>
